"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Localities$ = exports.Localities$outboundSchema = exports.Localities$inboundSchema = void 0;
exports.localitiesToJSON = localitiesToJSON;
exports.localitiesFromJSON = localitiesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.Localities$inboundSchema = z.object({
    brownfield_name: z.nullable(z.string()),
    conservation_area: z.nullable(z.string()),
    country: z.nullable(z.string()),
    county: z.nullable(z.string()),
    greenbelt_name: z.nullable(z.string()),
    local_authority: z.nullable(z.string()),
    local_authority_code: z.nullable(z.string()),
    national_park: z.nullable(z.string()),
    nearby_ancient_woodland: z.nullable(z.boolean()),
    parliamentary_constituency_name: z.nullable(z.string()),
    police_force: z.nullable(z.string()),
    primary_care_organisation: z.nullable(z.string()),
    rural_urban_classification: z.nullable(z.string()),
    ward: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "brownfield_name": "brownfieldName",
        "conservation_area": "conservationArea",
        "greenbelt_name": "greenbeltName",
        "local_authority": "localAuthority",
        "local_authority_code": "localAuthorityCode",
        "national_park": "nationalPark",
        "nearby_ancient_woodland": "nearbyAncientWoodland",
        "parliamentary_constituency_name": "parliamentaryConstituencyName",
        "police_force": "policeForce",
        "primary_care_organisation": "primaryCareOrganisation",
        "rural_urban_classification": "ruralUrbanClassification",
    });
});
/** @internal */
exports.Localities$outboundSchema = z.object({
    brownfieldName: z.nullable(z.string()),
    conservationArea: z.nullable(z.string()),
    country: z.nullable(z.string()),
    county: z.nullable(z.string()),
    greenbeltName: z.nullable(z.string()),
    localAuthority: z.nullable(z.string()),
    localAuthorityCode: z.nullable(z.string()),
    nationalPark: z.nullable(z.string()),
    nearbyAncientWoodland: z.nullable(z.boolean()),
    parliamentaryConstituencyName: z.nullable(z.string()),
    policeForce: z.nullable(z.string()),
    primaryCareOrganisation: z.nullable(z.string()),
    ruralUrbanClassification: z.nullable(z.string()),
    ward: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        brownfieldName: "brownfield_name",
        conservationArea: "conservation_area",
        greenbeltName: "greenbelt_name",
        localAuthority: "local_authority",
        localAuthorityCode: "local_authority_code",
        nationalPark: "national_park",
        nearbyAncientWoodland: "nearby_ancient_woodland",
        parliamentaryConstituencyName: "parliamentary_constituency_name",
        policeForce: "police_force",
        primaryCareOrganisation: "primary_care_organisation",
        ruralUrbanClassification: "rural_urban_classification",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Localities$;
(function (Localities$) {
    /** @deprecated use `Localities$inboundSchema` instead. */
    Localities$.inboundSchema = exports.Localities$inboundSchema;
    /** @deprecated use `Localities$outboundSchema` instead. */
    Localities$.outboundSchema = exports.Localities$outboundSchema;
})(Localities$ || (exports.Localities$ = Localities$ = {}));
function localitiesToJSON(localities) {
    return JSON.stringify(exports.Localities$outboundSchema.parse(localities));
}
function localitiesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Localities$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Localities' from JSON`);
}
//# sourceMappingURL=localities.js.map